import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import { MdSearch, MdClose } from 'react-icons/md';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CustomTypeahead = ({
	id,
	labelKey,
	onChange,
	options,
	placeholder,
	emptyLabel,
	linkToCreate,
	newOption,
	onCreate,
	selected,
	disabled,
	variant = 'default',
}) => {
	const inputRef = useRef(null);
	const isEntityVariant = variant === 'entity';

	const handleIconClick = () => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	};

	const renderEmptyLabel = () => {
		if (onCreate) {
			return (
				<a
					className={isEntityVariant ? 'dropdown-item entity-typeahead-create' : 'dropdown-item'}
					tabIndex={-1}
					role='button'
					onMouseDown={(e) => {
						e.preventDefault();
						onCreate();
					}}
				>
					...Crear {newOption}
				</a>
			);
		}
		if (linkToCreate) {
			return (
				<Link to={linkToCreate} className={isEntityVariant ? 'dropdown-item entity-typeahead-create' : 'dropdown-item'} tabIndex={-1}>
					...Crear {newOption}
				</Link>
			);
		}
		return null;
	};

	//customized render menu

	const renderMenu = (results, menuProps) => {
		// Filter out renderMenuItemChildren and other non-DOM props
		// eslint-disable-next-line no-unused-vars
		const { renderMenuItemChildren, ...validMenuProps } = menuProps;
		
		if (results.length === 0) {
			//no results
			return (
				<Menu {...validMenuProps} className={isEntityVariant ? 'entity-typeahead-menu' : undefined}>
					<MenuItem disabled>{emptyLabel}</MenuItem>
					{renderEmptyLabel()}
				</Menu>
			);
		}

		return (
			<Menu {...validMenuProps} className={isEntityVariant ? 'entity-typeahead-menu' : undefined}>
				{results.map(
					(
						option,
						index, //all the results+new option
					) => (
						<MenuItem key={index} option={option} position={index}>
							{labelKey(option)}
						</MenuItem>
					),
				)}
				{(onCreate || (linkToCreate && linkToCreate != '')) && renderEmptyLabel()}
			</Menu>
		);
	};
	return (
		<div className={isEntityVariant ? 'entity-typeahead' : undefined} style={{ position: 'relative' }}>
			<Typeahead
				id={id}
				labelKey={labelKey}
				onChange={onChange}
				options={options}
				placeholder={placeholder}
				selected={selected}
				disabled={disabled}
				emptyLabel={renderEmptyLabel()}
				renderInput={({ inputRef, ...props }, state) => {
					// Filter out referenceElementRef and other non-DOM props
					// eslint-disable-next-line no-unused-vars
					const { referenceElementRef, ...validInputProps } = props;
					return (
						<div className={isEntityVariant ? 'entity-typeahead-control d-flex' : 'd-flex'}>
							<Form.Control
								{...validInputProps}
								className={isEntityVariant ? `${validInputProps.className || ''} entity-typeahead-input` : validInputProps.className}
								style={isEntityVariant ? undefined : { flex: 1, borderRadius: '0.25rem 0 0 0.25rem' }}
								isInvalid={validInputProps.isInvalid}
								ref={inputRef}
							/>
							{state.selected.length === 0 && (
								<span
									className={isEntityVariant ? 'entity-typeahead-icon d-flex justify-content-center align-items-center' : 'input-group-text d-flex justify-content-center align-items-center typeahedSearchIcon'}
									onClick={handleIconClick}
								>
									<MdSearch />
								</span>
							)}
							{state.selected.length > 0 && !disabled && (
								<span
									className={isEntityVariant ? 'entity-typeahead-icon d-flex justify-content-center align-items-center' : 'input-group-text d-flex justify-content-center align-items-center typeahedSearchIcon'}
									onClick={() => {
										state.onClear();
										onChange([]); // clear the selected state
									}}
								>
									<MdClose />
								</span>
							)}
						</div>
					);
				}}
				renderMenu={renderMenu}
			/>
		</div>
	);
};

CustomTypeahead.propTypes = {
	id: PropTypes.string.isRequired,
	labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
	onChange: PropTypes.func.isRequired,
	options: PropTypes.array.isRequired,
	placeholder: PropTypes.string,
	emptyLabel: PropTypes.node,
	linkToCreate: PropTypes.string,
	newOption: PropTypes.string,
	onCreate: PropTypes.func,
	selected: PropTypes.array,
	disabled: PropTypes.bool,
	variant: PropTypes.oneOf(['default', 'entity']),
};

export default CustomTypeahead;
